import React from 'react';
import { ResponsiveContainer } from 'recharts';
import Areachart from '../Areachart/Areachart';
import Barchart from '../Barchart/Barchart';


const Dashboard = () => {

    return (
        <div className='d-flex'>
            <div>
                <Areachart></Areachart>
            </div>
            <div>
                <Barchart></Barchart>
            </div>
        </div>
            
            
     
    
    );
};

export default Dashboard;